export const ReportsOverviewPage = () => {
  return (
    <section>
      <h2>Prüfberichte</h2>
      <p style={{ marginTop: '12px', color: '#3b4b66' }}>
        Deine abgeschlossenen Prüfberichte werden hier zur Freigabe angezeigt.
      </p>
    </section>
  );
};
